module.exports = __webpack_public_path__ + "img/rocketslot_portrait_background.e9b6d221.png";